import { ValidateJSModel } from 'forms/shared/types';
import { hasYesOrNo } from 'models/validate';
import { FinancialAlimonyModel } from './types';
import { financialAlimonyItemValidator } from './validators/item';

const financialAlimonyValidator: ValidateJSModel<FinancialAlimonyModel> = {
  HasAlimony: (value, attributes) => {
    if (attributes?.HasAlimonyNotApplicable?.applicable !== false) {
      return {
        presence: true,
        hasValue: { validator: hasYesOrNo },
      };
    }
    return {};
  },

  HasAlimonyNotApplicable: {},

  List: (value, attributes) => {
    if (attributes?.HasAlimony?.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: financialAlimonyItemValidator },
      };
    }

    return {};
  },
};

export default financialAlimonyValidator;
